/**
 * RW-M17 (legado) — pilha LIFO de overlays para o voltar nativo fechar antes de navegar.
 * Só o caminho do kill-switch `OVERLAY_STACK_V2=false` (`useOverlay` legado) empilha aqui;
 * com a pilha única ligada, o `nativeBackHandler` consulta o `overlayManager` primeiro.
 */
type NativeOverlayCloser = () => boolean

const overlayStack: NativeOverlayCloser[] = []

export const pushNativeOverlay = (close: NativeOverlayCloser): (() => void) => {
  overlayStack.push(close)
  return () => {
    const index = overlayStack.lastIndexOf(close)
    if (index >= 0) overlayStack.splice(index, 1)
  }
}

export const closeTopNativeOverlay = (): boolean => {
  while (overlayStack.length > 0) {
    const close = overlayStack[overlayStack.length - 1]
    overlayStack.pop()
    if (close()) return true
  }
  return false
}

export const clearNativeOverlayStack = (): void => {
  overlayStack.length = 0
}
